import { toRgba } from '../../../utils/to-rgba/to-rgba.js';
function lighten(color, alpha) {
    if (typeof color === "string" && color.startsWith("var(--")) {
        return color;
    }
    var _toRgba = toRgba(color), r = _toRgba.r, g = _toRgba.g, b = _toRgba.b, a = _toRgba.a;
    var light = function(input) {
        return Math.round(input + (255 - input) * alpha);
    };
    return "rgba(".concat(light(r), ", ").concat(light(g), ", ").concat(light(b), ", ").concat(a, ")");
}
export { lighten }; //# sourceMappingURL=lighten.js.map
